export enum AppAssessmentLevel{
	VERY_LOW = 'VERY_LOW',
	LOW = 'LOW',
	MEDIUM = 'MEDIUM',
	HIGH = 'HIGH',
	VERY_HIGH = 'VERY_HIGH',
}
